var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifetime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#BC35A1",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    fill: "#BC35A1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.67,
    d: "M7.1 7.1v3.062h.356m9.406 1.225a4.9 4.9 0 0 0-9.406-1.225m0 0h2.707M16.9 16.9v-3.063h-.356m0 0a4.901 4.901 0 0 1-9.406-1.225m9.406 1.225h-2.706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifetime);
export default __webpack_public_path__ + "static/media/lifetime.171befeb02bf8db47d4bb328c2381dfb.svg";
export { ForwardRef as ReactComponent };